import PeerReview from "../components/PeerReview";

export default function PeerReviewPage() {
  return (
    <section className="py-10">
      <PeerReview />
    </section>
  );
}
